import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { IlsModelService } from '../../shared/services/ils-model.service'
import { Content } from '@monorepo/golab-generated'
import { ContentListComponent } from '../content-list/content-list.component'

interface PhaseStatus {
  id: string
  loaded: boolean
  contentList: Content[]
}

@Component({
  selector: 'app-phase-content',
  templateUrl: './phase-content.component.html',
  styleUrls: ['./phase-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ContentListComponent],
})
export class PhaseContentComponent implements OnInit {
  private ilsModelService = inject(IlsModelService)

  phaseStatusList: PhaseStatus[] = []

  get currentPhaseId(): string {
    return this.ilsModelService.currentPhaseId
  }

  ngOnInit(): void {
    this.ilsModelService.ilsLoaded$.subscribe((isLoaded) => {
      if (isLoaded) {
        this.phaseStatusList.length = 0
        this.ilsModelService.phaseList.forEach((phase) => {
          this.phaseStatusList.push({
            id: phase._id,
            loaded: false,
            contentList: phase.contentList,
          })
        })
        this.ilsModelService.currentPhaseId$.subscribe((id) => {
          if (id) {
            this.phaseStatusList.forEach((phaseStatus) => {
              if (phaseStatus.id === id) {
                phaseStatus.loaded = true
              }
            })
          }
        })
      }
    })
  }
}
